import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { Container } from "react-bootstrap";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { EditarMarca } from "../../Api/Marcas.Api";
import { useNavigate } from "react-router-dom";
import { Loader } from "../Principales";

export const FormEditMarca = ({ id }) => {
  const [maById, setMaById] = useState({});

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const data = useSelector((state) => state.Marcas.data);

  useEffect(() => {
    const res = data.filter((e) => e.ma_iden === id);
    setMaById(res[0]);
  }, [id, data]);

  const { ma_desc } = maById;

  return Object.keys(maById).length === 0 ? (
    <Loader />
  ) : (
    <Container>
      <Formik
        initialValues={{
          ma_desc: ma_desc,
        }}
        onSubmit={(values) => {
          Swal.fire({
            title: "Editar Marca ?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Editar !",
          }).then((result) => {
            if (result.isConfirmed) {
              (async (_) => {
                dispatch(EditarMarca({ id, values })).then((res) => {
                  if (res.meta.requestStatus === "fulfilled") {
                    Swal.fire({
                      icon: "success",
                      text: "Marca Editada",
                      toast: true,
                      position: "top-end",
                      timer: 2800,
                      showConfirmButton: false,
                    });
                    navigate("/Marcas");
                  } else {
                    Swal.fire({
                      icon: "info",
                      title: "Respuesta del Servidor",
                      text: "Vuelve a Iniciar sessión, si persiste el problema contáctanos",
                    });
                  }
                });
              })();
            }
          });
        }}
      >
        {({ handleChange }) => (
          <Form
            style={{ display: "flex", flexDirection: "column", gap: "8px" }}
          >
            <label>Modifica Descripcion:</label>
            <input
              type="text"
              name="ma_desc"
              placeholder={ma_desc}
              onChange={handleChange}
            />
            <div>
              <button type="submit">Editar</button>
            </div>
          </Form>
        )}
      </Formik>
    </Container>
  );
};
